import React from 'react';
import { compose, prop } from 'ramda';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import renderIf from 'app/enhancers/renderIf';
import wrapIn from 'app/enhancers/wrapIn';
import S from 'app/features/success/components/Cards.styled';
import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';
import LatestNews from 'app/features/success/latestNewsBlock/components/LatestNews';
import Heading from 'app/components/layout/Heading.styled';
import CallToAction from 'app/components/layout/CallToAction.styled';
import { NEWS_URL } from 'app/router/constants/externalUrls';
import BlockWrapper from 'app/features/success/components/BlockWrapper';
import ActionLink from 'app/components/Links/ActionLink.styled';
import { isVisible } from 'app/features/success/latestNewsBlock/selectors';
import withDispatchOnMount from 'app/enhancers/withDispatchOnMount';
import { fetchLatestNews } from 'app/features/news/actions';

const UI = () => (
  <article data-t="topnews-block">
    <S.CardsHolder.Header>
      <Heading size="l" as="h2">
        <FormattedMessage id="success_news_cards_title" />
      </Heading>
      <ActionLink as={LocalizedLink} to={NEWS_URL}>
        <CallToAction size="l">
          <FormattedMessage id="success_cards_cta" />
        </CallToAction>
      </ActionLink>
    </S.CardsHolder.Header>
    <S.News.Holder>
      <LatestNews />
    </S.News.Holder>
  </article>
);

UI.displayName = 'LatestNewsBlock';

const LatestNewsBlock = compose(
  withDispatchOnMount(fetchLatestNews),
  connect({ isVisible }),
  renderIf(prop('isVisible')),
  wrapIn(BlockWrapper),
)(UI);

export { UI };

export default LatestNewsBlock;
